import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import {
  ITINERARY_BOARDING_REPORT,
} from '../../config/endpoints';
import {
  DEFAULT_GET_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_ITINERARY_BOARDING_REPORTS,
  FLAG_GETTING_ITINERARY_BOARDING_REPORTS,
  GET_ITINERARY_BOARDING_REPORTS,
} from '../types';

const flagItineraryBoardingReportsActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_ITINERARY_BOARDING_REPORTS,
    payload: flag,
  });

const getAllItineraryBoardingReports =
  ({
    boardingAgencyId,
    destinationLocationIds,
    fromDateString,
    toDateString,
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagItineraryBoardingReportsActivity(true));

      const query = {
        boardingAgencyId,
        destinationLocationIds,
        fromDateString,
        toDateString,
      };

      const url = `${ITINERARY_BOARDING_REPORT}?${QueryString.stringify(query)}`;

      const response = await fetch(url, {
        ...DEFAULT_GET_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      const data = await response.json();
      dispatch({
        type: GET_ITINERARY_BOARDING_REPORTS,
        payload: data,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagItineraryBoardingReportsActivity(false));
    }
  };

  const exportBoardingReportFile = ({
    boardingAgencyId,
    destinationLocationIds,
    fromDateString,
    toDateString,
  }) => async (dispatch) => {
    try {
      const query = {
        boardingAgencyId,
        destinationLocationIds,
        fromDateString,
        toDateString,
      };
      dispatch(flagItineraryBoardingReportsActivity(true));
      const url = `${ITINERARY_BOARDING_REPORT}/export?${QueryString.stringify(query)}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(response, null, dispatch);
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', 'Report-Embarque.xlsx');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagItineraryBoardingReportsActivity(false));
    }
  }

const clearItineraryBoardingReports = () => (dispatch) => {
  dispatch({
    type: CLEAR_ITINERARY_BOARDING_REPORTS,
  });
};

export {
  flagItineraryBoardingReportsActivity,
  getAllItineraryBoardingReports,
  clearItineraryBoardingReports,
  exportBoardingReportFile
};